import React from 'react';

import { ChatMessageSystem } from '../ChatMessageSystem';

type SystemMessageProps = {
  text: string;
};

export function SystemMessage({ text }: SystemMessageProps) {
  return <ChatMessageSystem text={text} />;
}
